import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import CheckCircleOutlineOutlinedIcon from '@mui/icons-material/CheckCircleOutlineOutlined';
import CircleOutlinedIcon from '@mui/icons-material/CircleOutlined';
import ReportProblemOutlinedIcon from '@mui/icons-material/ReportProblemOutlined';
import SwapHorizontalCircleOutlinedIcon from '@mui/icons-material/SwapHorizontalCircleOutlined';
import { Box, lighten, styled } from '@mui/material';
import { PrimaryButton } from 'apps/wrapper/src/components/shared/buttons';
import moment from 'moment';
import AiIcon from '../../../../../../../../assets/images/ai-icon.svg';

export const ListItemWrapper = styled(Box)({
  display: 'flex',
  flex: 1,
  margin: '0 15px 0 15px',
  borderBottom: '1px solid #E9EAEE',
  flexDirection: 'row',
  alignItems: 'stretch'
});

export const ListItemHover = styled(Box)<{ isdirectbooking: string }>(({ isdirectbooking }) => ({
  display: 'flex',
  padding: '12px 0',
  flex: 1,
  backgroundColor: isdirectbooking == 'true' ? '#E6F3FF' : '#FFFFFF',
  '&:hover': {
    backgroundColor: isdirectbooking == 'true' ? lighten('#E6F3FF', 0.3) : '#f5f5f5',
    cursor: 'pointer'
  }
}));

export const ListItemStatus = styled(Box)(() => ({
  padding: '4px 8px'
}));

export const ListItem = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
  marginRight: '10px'
}));

export const ListItemTitle = styled(Box)({
  padding: '0',
  margin: 0,
  display: 'flex',
  alignItems: 'start',
  justifyContent: 'space-between'
});

export const PatientNameWrapper = styled(Box)({
  display: 'flex',
  flexWrap: 'wrap',
  maxWidth: '165px'
});

export const PatientName = styled(Box)({
  fontWeight: 700,
  fontSize: '16px',
  lineHeight: '160%',
  letterSpacing: '0.15px',
  textOverflow: 'ellipsis',
  display: '-webkit-box',
  '-webkit-line-clamp': '2',
  '-webkit-box-orient': 'vertical',
  whiteSpace: 'normal',
  overflow: 'hidden'
});

export const DateAndType = styled(Box)(() => ({
  marginLeft: 'auto',
  display: 'flex',
  flexDirection: 'column'
}));

export const RequestDate = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  fontSize: '12px',
  lineHeight: '18px',
  letterSpacing: '0.4px',
  color: 'black',
  position: 'relative'
}));

export const AppointmentType = styled(Box)({
  fontSize: '14px',
  letterSpacing: '0.15px'
});

export const RequestType = styled(Box)({
  fontSize: '12px',
  letterSpacing: '0.15px'
});

export const ListItemContent = styled(Box)({
  display: 'flex',
  flexDirection: 'row'
});

export const AppointmentTimes = styled('ul')({
  margin: 0,
  padding: 0,
  listStyle: 'none',
  fontSize: '14px',
  letterSpacing: '0.15px',
  marginTop: '2px'
});

export const AppointmentTime = styled('li')({
  padding: 0,
  margin: 0
});

export const RequestComment = styled(Box)({
  fontSize: '14px',
  letterSpacing: '0.15px',
  marginTop: '2px'
});

export const ListItemFooter = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  marginTop: '7px'
});

export const WritebackProcessingStatusMessage = styled(() => (
  <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
    <SwapHorizontalCircleOutlinedIcon sx={{ width: '17px', height: '17px', marginRight: '5px', color: '#E17C00' }} />
    Writeback processing
  </Box>
))({});

export const PendingReviewStatusMessage = styled(() => (
  <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
    <ReportProblemOutlinedIcon sx={{ width: '17px', height: '17px', marginRight: '5px', color: '#E17C00' }} />
    Pending review
  </Box>
))({});

export const WritebackFailedStatusMessage = styled(() => (
  <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
    <CancelOutlinedIcon sx={{ width: '17px', height: '17px', marginRight: '5px', color: '#E31B0C' }} />
    Writeback to PMS failed
  </Box>
))({});

export const DismissedStatusMessage = styled(({ date }: { date: Date }) => (
  <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
    <CircleOutlinedIcon sx={{ width: '17px', height: '17px', marginRight: '5px', color: '#008A06' }} />
    Dismissed on {moment(date).format('MM/DD/YYYY')}
  </Box>
))({});

export const ApprovedStatusMessage = styled(({ date }: { date: Date }) => (
  <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
    <CheckCircleOutlineOutlinedIcon sx={{ width: '17px', height: '17px', marginRight: '5px', color: '#008A06' }} />
    Approved on {moment(date).format('MM/DD/YYYY')}
  </Box>
))({});

export const DirectBookingSuccessStatusMessage = styled(({ date }: { date?: Date | string | null }) => {
  const m = moment(date);
  const text = m.isValid() ? `Directly scheduled on ${m.format('MM/DD/YYYY')}` : 'Directly scheduled';
  return (
    <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
      <CheckCircleOutlineOutlinedIcon sx={{ width: '17px', height: '17px', marginRight: '5px', color: '#008A06' }} />
      {text}
    </Box>
  );
})({});

export const StatusIcons = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  marginLeft: 'auto',
  flexDirection: 'row'
}));

export const AiStatus = styled(() => (
  <Box
    sx={{
      backgroundColor: '#8cc1f1',
      borderRadius: '50%',
      marginLeft: '4px',
      width: '18px',
      height: '18px',
      display: 'flex'
    }}
  >
    <img
      src={AiIcon}
      alt=""
      style={{ color: 'white', display: 'flex', margin: 'auto', width: '14px', height: '14px' }}
    />
  </Box>
))(() => ({}));

export const StatusMessage = styled(Box)(() => ({
  display: 'flex',
  fontSize: '12px',
  letterSpacing: '0.15px',
  lineHeight: '160%',
  flexDirection: 'column'
}));

export const BlueDot = styled(Box)(() => ({
  width: '6px',
  height: '6px',
  borderRadius: '50%',
  backgroundColor: '#0675DD',
  display: 'inline-block'
}));

export const GoToDetailsButton = styled(PrimaryButton)(() => ({
  width: '26px',
  height: 'auto',
  display: 'flex',
  padding: 0,
  borderRadius: 0,
  minWidth: '26px',
  backgroundColor: 'white',
  color: '#0675DD',
  '&:hover': {
    color: 'white',
    backgroundColor: '#0675DD'
  }
}));
